<svelte:options customElement={{ tag: 'bt-icon', shadow: 'none' }} />

<script lang="ts">
  import icons from '$lib/components/shared/icons/icons';

  export let icon = '';
  export let iconClass = '';
  export let size: 'extra-small' | 'small' | 'medium' | 'large' | 'auto' = 'auto';
  export let hidden = false;
</script>

<svelte:component this={icons[icon]} iconClass={`bt-icon ${size} ${iconClass} ${hidden ? 'hidden' : ''}`}
/>

<style>
  :global(.bt-icon.extra-small) {
    width: theme('size.3');
    height: theme('size.3');
  }
  :global(.bt-icon.small) {
    width: theme('size.4');
    height: theme('size.4');
  }
  :global(.bt-icon.medium) {
    width: theme('size.6');
    height: theme('size.6');
  }
  :global(.bt-icon.large) {
    width: theme('size.16');
    height: theme('size.16');
  }
  :global(.bt-icon.hidden) {
    display: none;
  }
</style>
